import {mapState} from "vuex";

export default {

    data() {
        return {
            cell_width: 100,
            target: null,
            books: {},
            single: {},
            show_details: false,
            tencent: {},
            welink:{},
            platform: 'zoom'
        }
    },
    created() {
        this.target = new Date().Format('yyyy-MM-dd');
        if (this.hasZoom) this.platform = 'zoom';
        else if (this.hasTencent) this.platform = 'tencent';
        else if (this.hasWelink) this.platform = 'welink';
    },
    mounted() {
        this.reload();
    },
    computed: {
        ...mapState(['process', 'preset']),
        hasZoom() {
            const groups = this.preset.app.room_groups;
            if (groups) {
                for (let i = 0; i < groups.length; i++) {
                    if (['0', '2', '3'].includes(groups[i].platform + '')) return true;
                }
            }
            return false;
        },
        hasTencent() {
            const groups = this.preset.app.room_groups;
            if (groups) {
                for (let i = 0; i < groups.length; i++) {
                    if (groups[i].platform + '' === '1') return true;
                }
            }
            return false;
        },
        hasWelink(){
            const groups = this.preset.app.room_groups;
            if (groups) {
                for (let i = 0; i < groups.length; i++) {
                    if (groups[i].platform + '' === '4') return true;
                }
            }
            return false;
        },
        ruleCells() {
            let ret = [];
            if (this.books) {
                const keys = Object.keys(this.books);
                if (keys.length > 0) {
                    const sample = this.books[keys[0]];
                    ret = Object.keys(sample.reserves);
                }
            } else {
                const keys = Object.keys(this.tencent);
                if (keys.length > 0) {
                    const sample = this.tencent[keys[0]];
                    ret = Object.keys(sample.reserves);
                }
            }
            return ret;

        },
        meetingRooms() {
            const ret = [];
            for (let key in this.books) {
                const item = this.books[key];
                ret.push(item.room);
            }
            return ret;
        },
        tencentRooms() {
            const ret = [];
            for (let key in this.tencent) {
                const item = this.tencent[key];
                ret.push(item.room);
            }
            return ret;
        },
        welinkRooms() {
            const ret = [];
            for (let key in this.welink) {
                const item = this.welink[key];
                ret.push(item.room);
            }
            return ret;
        }
    },
    methods: {
        next() {
            let date = this.$dateParse(this.target);
            date.setDate(date.getDate() + 7);
            this.target = date.Format('yyyy-MM-dd');
            this.reload();
        },
        previous() {
            let date = this.$dateParse(this.target);
            date.setDate(date.getDate() - 7);
            this.target = date.Format('yyyy-MM-dd');
            this.reload();
        },
        reload() {
            if (this.$is_date(this.target)) {
                this.$api('Query.View.Week', {date: this.target}, true).then(res => {
                    this.books = res.data.data[0];
                    this.tencent = res.data.data[1];
                    this.welink = res.data.data[2];
                });
            }
        },
        showResv(records, date) {
            this.single.records = records;
            this.single.date = date;
            this.show_details = true;
        }
    }
}
